import {
    SYSTEM_SUBMIT_AREA_BEGIN,
    SYSTEM_SUBMIT_AREA_SUCCESS,
    SYSTEM_SUBMIT_AREA_FAILURE,
    SYSTEM_SUBMIT_AREA_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitArea(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_AREA_BEGIN,
      });
  
      let apiurl = '/api/b/area/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/area/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_AREA_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_AREA_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitAreaError() {
    return {
      type: SYSTEM_SUBMIT_AREA_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_AREA_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitAreaPending: true,
          submitAreaError: null,
        };
  
      case SYSTEM_SUBMIT_AREA_SUCCESS:
        // The request is success
        return {
          ...state,
          submitAreaPending: false,
          submitAreaError: null,
        };
  
      case SYSTEM_SUBMIT_AREA_FAILURE:
        // The request is failed
        return {
          ...state,
          submitAreaPending: false,
          submitAreaError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_AREA_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitAreaError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitArea.js